import React from 'react';

import { Badge } from '@newsela/angelou';

import { getEnvironmentFlags } from '@client/utils/environment';

export default function NonProdEnv () {
  const dgraphHost = (typeof process !== 'undefined' && process.env && process.env.DGRAPH_HOST) ? process.env.DGRAPH_HOST : '';
  const usingSelfHostedDgraph = dgraphHost.includes('newsela.com') || dgraphHost.includes('newseladev.com');
  const hostname = window.location.hostname;
  const nonProdEnv = getEnvironmentFlags(hostname);
  let envComponent = null;
  let dgraphComponent = null;
  if (nonProdEnv) {
    envComponent = (
      <Badge
        text={`${nonProdEnv.name} Environment`}
        flavor={Badge.flavor.solid}
        color={Badge.color[nonProdEnv.color]}
        size={Badge.size.lg}
        hideIcon
      />
    );
    if (usingSelfHostedDgraph) {
      dgraphComponent = (
        <Badge
          text='Self-hosted DGraph'
          flavor={Badge.flavor.solid}
          color={Badge.color.red}
          size={Badge.size.lg}
          hideIcon
        />
      );
    }
  }
  return (
    <>
      {envComponent}
      {dgraphComponent}
    </>
  );
}
